<template>
  <div class="flex flex-between flex-vertical-center is-full-height">
    <div class="flex flex-between flex-vertical-center">
      <router-link :to="{ name: 'pipeline' }" class="flex flex-vertical-center">
        <img class="page_header--logo" src="/images/forefront-logo.png" alt="Forefront">
      </router-link>

      <div class="deal_count" @click="openDealListModal">
        <p class="deal_count--amount">{{ dealCountThisMonth }} DEALS</p>
        <p class="deal_count--subtitle">THIS MONTH</p>
      </div>
    </div>

    <div v-if="showHeaderAd" class="header_ad">
      <a :href="headerAd.link" target="_blank">
        <img :src="headerAd.image_url" :alt="headerAd.alt_text">
      </a>
    </div>

    <div class="page_header--nav">
      <page-header-search ref="searchbar"/>
      <div class="mx-100">
        <button-icon
          icon="recent-leads"
          @click="openRecentlyViewedLeadsModal"
          size=""
          color="is-secondary"
        />
      </div>

      <page-header-new-record/>
      <page-header-notifications/>
      <page-header-user-menu/>
    </div>

    <modal-before-container>
      <modal-default
        ref="recentlyViewModal"
        title="Recently Viewed Leads"
      >
        <recent-leads-modal/>
      </modal-default>

      <modal-default
        ref="dealListModal"
        title="Deals This Month"
      >
        <deal-list-modal/>
      </modal-default>
    </modal-before-container>
  </div>
</template>

<script>
import PageHeaderNotifications from "./components/PageHeaderNotifications";
import PageHeaderSearch from "./components/PageHeaderSearch";
import PageHeaderNewRecord from "./components/PageHeaderNewRecord";
import PageHeaderUserMenu from "./components/PageHeaderUserMenu";
import RecentLeadsModal from "./components/RecentLeadsModal";
import DealListModal from "./components/DealListModal";

export default {
  name: "PageHeader",
  components: {
    DealListModal,
    RecentLeadsModal,
    PageHeaderUserMenu,
    PageHeaderNewRecord,
    PageHeaderSearch,
    PageHeaderNotifications
  },
  data() {
    return {
      headerAd: {
        link: process.env.MIX_HEADER_AD_LINK,
        image_url: process.env.MIX_HEADER_AD_IMAGE_URL,
        alt_text: process.env.MIX_HEADER_AD_ALT_TEXT,
      }
    }
  },
  computed: {
    dealCountThisMonth() {
      return this.$store.getters.dealsCountThisMonth;
    },
    account() {
      return this.$store.state.account.account;
    },
    showHeaderAd() {
      return this.headerAd.image_url !== 'null' && !!this.headerAd.image_url;
    },
  },
  methods: {
    openDealListModal() {
      this.$refs.dealListModal.open();
    },
    openRecentlyViewedLeadsModal() {
      this.$refs.recentlyViewModal.open();
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

$logoHeight: 28px;
.page_header {

  &--logo {
    height: $logoHeight;
  }

  &--nav {
    display: flex;
    align-items: center;
  }
}

.deal_count {
  margin-left: 20px;
  text-align: center;
  cursor: pointer;

  &--amount {
    margin-bottom: 2px;
    color: $primary;
    font-weight: bold;
  }

  &--subtitle {
    font-size: 8px;
    color: $text-muted;
    letter-spacing: 1px;
  }
}

.header_ad {
  width: 420px;
  height: 36px;
  overflow: hidden;
}
</style>
